@import ../../styles/helpers

.loader
    position: relative
    width: 40px
    height: 40px
    &:before
        animation: 1.5s linear infinite loader
        animation-play-state: inherit
        border: solid 5px $light
        border-bottom-color: $primary
        border-radius: 50%
        content: ""
        height: 100%
        position: absolute
        top: 10%
        left: 10%
        transform: translate3d(-50%, -50%, 0)
        width: 100%
        will-change: transform

@keyframes loader
  0%
    transform: rotate(0deg)
  100%
    transform: rotate(360deg)
